/**
 * Dashboard 仪表盘常量
 */

/** 与 Figma「7 Days / 1 Month / All」一致；前端按歌曲 `publishTime`（Unix 秒）筛选列表 */
export const TIME_RANGE_OPTIONS = [
  { label: '7 Days', value: '7d' },
  { label: '1 Month', value: '30d' },
  { label: 'All', value: 'all' },
] as const;

export type TimeRange = (typeof TIME_RANGE_OPTIONS)[number]['value'];
